import React from 'react';
import { MChipGroupProps } from './MChipGroup.types';
import * as Styled from './MChipGroup.styles';
import { MQuickSelectChip } from '../MQuickSelectChip';

export const MChipGroup: React.FC<MChipGroupProps> = ({ chips, className, variant = 'default', ...rest }) => {
  return (
    <Styled.Wrapper className={className} {...rest}>
      {chips.map((chip, index) => (
        <MQuickSelectChip key={index} variant={variant} {...chip} />
      ))}
    </Styled.Wrapper>
  );
};

export type { MChipGroupProps } from './MChipGroup.types';
